import {
  ApolloError,
  DocumentNode,
  useMutation,
  useQuery,
} from "@apollo/client";
import { DropdownFillers } from "./types";
import { FormFieldComponentProps } from "./components/new_form/form_fields/FormFieldComponent";
import { NewMultipleFormComponentProps } from "./components/new_form/NewMultipleFormComponentProps";

export const emptyDropdownFillers: DropdownFillers[] = [];

export const handleAPIError = (
  error: ApolloError,
  followupFunction?: (error: ApolloError) => boolean,
) => {
  if (JSON.stringify(error) === "{}") {
    return;
  }
  if (followupFunction) {
    if (followupFunction(error)) {
      return;
    }
  }
  if (error.message !== undefined) {
    if (error.message === "Invalid Session") {
      window.location.href = "/login";
      localStorage.removeItem("second-brain-session");
      return;
    }
    if (
      error.graphQLErrors[0].message ===
      'Variable "$session" of non-null type "String!" must not be null.'
    ) {
      return;
    }
  }
  alert(JSON.stringify(error));
};

export function getSession(): string | null {
  return localStorage.getItem("second-brain-session");
}

export function getEventSession(): string | null {
  return localStorage.getItem("second-brain-event-session");
}

export function getVersion(): {
  majorVersion: number;
  minorVersion: number;
  patchVersion: number;
} {
  return { majorVersion: 0, minorVersion: 9, patchVersion: 0 };
}

export function getEventMetadata(): {
  source: number;
  version: { majorVersion: number; minorVersion: number; patchVersion: number };
  event_session?: string | null;
} {
  return { source: 1, version: getVersion(), event_session: getEventSession() };
}

// eslint-disable-next-line
export const useQueryWrapper = (query: DocumentNode, variables: any, onCompletedMethod: (data: any) => void) => {
  useQuery(query, {
    variables: variables,
    onCompleted: (data) => onCompletedMethod(data),
    onError: (error: ApolloError) => {
      alert("queryError");
      alert(JSON.stringify(error));
      handleAPIError(error);
    },
    fetchPolicy: "no-cache",
  });
};

// eslint-disable-next-line
export const useMutationWrapper = (mutation: DocumentNode, onCompletedMethod: (data: any) => void, onError?: (error: ApolloError) => boolean) => {
  return useMutation(mutation, {
    onCompleted: (data) => onCompletedMethod(data),
    onError: (error: ApolloError) => {
      alert("mutationError");
      alert(JSON.stringify(error));
      handleAPIError(error, onError);
    },
  });
};

// eslint-disable-next-line
export const logEventCompleted = (data: any) => {
  localStorage.setItem("second-brain-event-session", data.logEvent);
};

export function parseDate(date: Date) {
  alert(date);
  const today = (date as Date).toISOString().slice(0, 10);
  const year = Number(today.split("-")[0]);
  const month = Number(today.split("-")[1]);
  const day = Number(today.split("-")[2]);
  return { year: year, month: month, day: day };
}

export function anyStringBlank(strings: string[]): boolean {
  for (const string of strings) {
    if (string === undefined) {
      return true;
    }
    if (string === "") {
      return true;
    }
  }
  return false;
}

export function appendIdToMultipleFormComponentProps(
  form: NewMultipleFormComponentProps,
  data: { id: number },
): NewMultipleFormComponentProps {
  const newFormFields = [] as FormFieldComponentProps[][];
  for (const formFieldArray of form.formFields) {
    const newFormFieldArray = [] as FormFieldComponentProps[];
    for (const formField of formFieldArray) {
      newFormFieldArray.push(formField);
    }
    newFormFieldArray.push({
      type: "hardcoded",
      key: "id",
      value: data.id,
    });
    newFormFields.push(newFormFieldArray);
  }
  return {
    type: "multiple_form",
    formFields: newFormFields,
    typeSelector: form.typeSelector,
  };
}

export function appendIdToFormFields(
  formFields: FormFieldComponentProps[],
  data: { id: number },
): FormFieldComponentProps[] {
  const newFormFields = [] as FormFieldComponentProps[];
  for (const formField of formFields) {
    newFormFields.push(formField);
  }
  newFormFields.push({
    type: "hardcoded",
    key: "id",
    value: data.id,
  });
  return newFormFields;
}
